module.exports = __webpack_public_path__ + "static/img/smaco-11.0b2e8fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/smaco-11.jpg
// module id = nr+L
// module chunks = 1